import type { Dispatch, SetStateAction } from 'react';
import { useEffect, useState } from 'react';

const safeJSONParse = <T>(value: string | null): T | null => {
  try {
    return JSON.parse(value ?? '') as T;
  } catch {
    // Don't need to do anything here, if the value fails to parse we return a null
    return null;
  }
};

/**
 * @deprecated use useLocalStorage from @hotjar/insights-common
 */
export const useLocalStorageValue = (
  key: string,
): [string | null, Dispatch<SetStateAction<string | null>>] => {
  const [value, setValue] = useState(localStorage.getItem(key));

  useEffect(() => {
    localStorage.setItem(key, String(value));
  }, [key, value]);

  return [value, setValue];
};

// Use this whenever you want to work with non string values, for example numbers, boolean, and JSON objects.
/**
 * @deprecated use useLocalStorageJSONValue from @hotjar/insights-common
 */
export const useLocalStorageJSONValue = <T>(
  key: string,
): [T | null, Dispatch<SetStateAction<T | null>>] => {
  const [value, setValue] = useState(safeJSONParse<T>(localStorage.getItem(key)));

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);

  return [value, setValue];
};
